import React from "react";
import { FaCheck, FaRedo, FaTimes } from "react-icons/fa";

import { useArbitrageQuiz } from "../hooks/useArbitrageQuiz";

function ArbitrageQuizPanel() {
  const {
    questions,
    currentQuestion,
    currentIndex,
    score,
    errors,
    showResults,
    progress,
    startQuiz,
    answerQuestion,
  } = useArbitrageQuiz(10);

  if (!questions.length) {
    return null;
  }

  if (showResults) {
    return (
      <section className="mt-6 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20 sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-amber-600 dark:text-amber-200">
              Résultat du quiz
            </p>

            <h2 className="mt-2 font-titre text-3xl font-bold text-slate-950 dark:text-white">
              Score : {score} / {questions.length}
            </h2>

            <p className="mt-2 text-sm font-medium text-slate-500 dark:text-white/50">
              Revoyez les bonnes réponses et recommencez pour progresser.
            </p>
          </div>

          <button
            type="button"
            onClick={startQuiz}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-amber-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5"
          >
            <FaRedo />
            Recommencer
          </button>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {questions.map((question) => {
            const error = errors.find((item) => item.id === question.id);
            const isCorrect = !error;

            return (
              <article
                key={question.id}
                className={`rounded-[1.5rem] border p-4 ${
                  isCorrect
                    ? "border-emerald-200 bg-emerald-50 dark:border-emerald-400/20 dark:bg-emerald-500/10"
                    : "border-red-200 bg-red-50 dark:border-red-400/20 dark:bg-red-500/10"
                }`}
              >
                <div
                  className={`mb-3 inline-flex h-10 w-10 items-center justify-center rounded-2xl text-white ${
                    isCorrect ? "bg-emerald-600" : "bg-red-600"
                  }`}
                >
                  {isCorrect ? <FaCheck /> : <FaTimes />}
                </div>

                <h3 className="text-sm font-bold leading-6 text-slate-950 dark:text-white">
                  {question.question}
                </h3>

                {error && (
                  <p className="mt-3 text-sm font-bold text-red-700 line-through dark:text-red-200">
                    {error.selectedAnswer}
                  </p>
                )}

                <p className="mt-2 text-sm font-bold text-emerald-700 dark:text-emerald-200">
                  {question.correctAnswer}
                </p>
              </article>
            );
          })}
        </div>
      </section>
    );
  }

  return (
    <section className="mt-6 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="bg-gradient-to-br from-slate-950 via-amber-950 to-amber-700 p-5 text-white sm:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-white/60">
              Quiz arbitrage
            </p>

            <h2 className="mt-2 font-titre text-3xl font-bold">
              Question {currentIndex + 1} / {questions.length}
            </h2>

            <p className="mt-2 max-w-3xl text-sm font-medium leading-7 text-white/70">
              {currentQuestion.question}
            </p>
          </div>

          <button
            type="button"
            onClick={startQuiz}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-white px-4 py-2 text-sm font-bold text-slate-950 transition hover:-translate-y-0.5"
          >
            <FaRedo />
            Nouveau quiz
          </button>
        </div>

        <div className="mt-5 h-3 overflow-hidden rounded-full bg-white/15">
          <div
            className="h-full rounded-full bg-amber-300 transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <div className="grid gap-3 p-4 sm:p-6 md:grid-cols-3">
        {currentQuestion.options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => answerQuestion(option)}
            className="inline-flex min-h-16 items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 px-5 py-4 text-center text-base font-bold text-slate-800 transition hover:-translate-y-0.5 hover:border-amber-200 hover:bg-white hover:text-amber-700 dark:border-white/10 dark:bg-white/[0.05] dark:text-white dark:hover:border-amber-300/40 dark:hover:text-amber-100"
          >
            {option}
          </button>
        ))}
      </div>
    </section>
  );
}

export default ArbitrageQuizPanel;